type TabItem = {
  key: string
  label: string
  to: string | null
  htmlId?: string
}

export const PAYROLL_CONFIG_NAV_TABS: TabItem[] = [
  {
    key: "pay-schedules",
    label: "Pay schedules",
    to: "/dashboard/payroll/configuration/pay-schedules",
  },
  {
    key: "paybands",
    label: "Paybands",
    to: "/dashboard/payroll/configuration/paybands",
    htmlId: "payroll-config-paybands",
  },
  {
    key: "paygrades",
    label: "Paygrades",
    to: "/dashboard/payroll/configuration/paygrades",
    htmlId: "payroll-config-paygrade",
  },
  {
    key: "allowances",
    label: "Allowances",
    to: "/dashboard/payroll/configuration/allowances",
    htmlId: "payroll-config-allowances",
  },
  {
    key: "shift-differentials",
    label: "Shift differentials",
    to: "/dashboard/payroll/configuration/shift-differentials",
    htmlId: "payroll-config-shift-differentials",
  },
  {
    key: "tax-reliefs",
    label: "Tax reliefs",
    to: "/dashboard/payroll/configuration/tax-reliefs",
    htmlId: "payroll-config-tax-reliefs",
  },
  {
    key: "statutory-benefits",
    label: "Statutory benefits",
    to: "/dashboard/payroll/configuration/statutory-benefits",
    htmlId: "payroll-config-benefits",
  },
  {
    key: "tax-tables",
    label: "Tax table",
    to: "/dashboard/payroll/configuration/tax-tables",
    htmlId: "payroll-config-tax",
  },
]

const PayrollConfigurationTabBar = ({
  activeKey,
  navigate,
}: {
  activeKey: string
  navigate: (to: string) => void
}) => (
  <div className="flex h-[54px] items-start overflow-x-auto slim-x-scroll bg-white">
    <div className="h-[54px] w-6 shrink-0 border-b-[1.4px] border-[#e2e8f0]" />
    {PAYROLL_CONFIG_NAV_TABS.map((tab) => {
      const isActive = tab.key === activeKey
      return (
        <button
          key={tab.key}
          id={tab.htmlId}
          type="button"
          onClick={() => tab.to && navigate(tab.to)}
          disabled={!tab.to}
          className={`flex h-[54px] shrink-0 items-center whitespace-nowrap border-b-[1.4px] px-3 font-circular text-[14px] leading-[1.5] transition-colors disabled:cursor-not-allowed ${
            isActive
              ? "border-[#004af5] font-bold text-[#004af5]"
              : "border-[#e2e8f0] font-normal text-[#62748e] hover:text-[#0f172b] disabled:hover:text-[#62748e]"
          }`}
        >
          {tab.label}
        </button>
      )
    })}
    <div className="h-[54px] min-w-0 flex-1 border-b-[1.4px] border-[#e2e8f0]" />
  </div>
)

export default PayrollConfigurationTabBar
